import { nextTick } from 'vue';
import { store } from '../../../../../resources/frontend/js/store/index';
import { updateParameter } from '../../quiz/history';
import scrollToSelector from '../../utils/scroll-to-selector';
import dataLayerPush from '../../utils/data-layer-push';

/**
 * Go to the next step
 */
export const goToNextStep = step => {
    const storePage = store.state.page;

    const nextStep = step || storePage.step + 1;

    store.commit('page/setValue', {
        key: 'previousStep',
        value: storePage.step,
    });

    if (storePage.step === storePage.totalSteps - 1) {
        dataLayerPush('Form step 1');
    }

    storePage.step = nextStep;
    updateParameter( 'data_step', storePage.step);

    if (!storePage.wrapper.hasAttribute('data-no-step-scroll')) {
        scrollToSelector('body');
    }

    dataLayerPush(`Step ${storePage.step}`);

    nextTick(() => {
        store.commit('cro/runStepChangeEvents', storePage.step);

        if (document.querySelector(`.step--${storePage.step} .question`)) {
            store.commit('page/increasePixelStep', { label: 'Question' });
            return;
        }

        if (document.querySelector(`.step--${storePage.step} .loadingscreen`)) {
            store.commit('page/increasePixelStep', { label: 'Loading' });
            return;
        }

        if (document.querySelector(`.step--${storePage.step} #form-wrapper`)) {
            store.commit('page/increasePixelStep', { label: 'Form' });
        }
    });
};

/**
 * Go to the previous step
 */
export const goToPreviousStep = step => {
    const storePage = store.state.page;

    const previousStep = step || storePage.step - 1;

    store.commit('page/setValue', {
        key: 'previousStep',
        value: storePage.step,
    });

    if (previousStep === 0) {
        storePage.step--;
    } else {
        storePage.step = previousStep;
    }

    storePage.wrapper.setAttribute('data-step', storePage.step);

    if (!storePage.wrapper.hasAttribute('data-no-step-scroll')) {
        scrollToSelector('body');
    }

    nextTick(() => {
        store.commit('cro/runStepChangeEvents', storePage.step);

        if (storePage.step === 1) {
            if (document.querySelector('.question')) {
                store.commit('page/decreasePixelStep', { label: 'Question' });
                return;
            }

            store.commit('page/decreasePixelStep', { label: 'Start' });
            return;
        }

        if (document.querySelector('.loadingscreen')) {
            store.commit('page/decreasePixelStep', { label: 'Loading' });
            return;
        }

        if (document.querySelector('#form-wrapper')) {
            store.commit('page/decreasePixelStep', { label: 'Form' });
        }
    });
};
